import React from 'react';
import { Row, Col, Card, Statistic, Typography } from 'antd';
import { UserOutlined, ProjectOutlined, TeamOutlined, TrophyOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const About = () => {

  return (
    <section id="about" className="section section-light">
      <div className="container">
        <div className="section-header">
          <Title level={2} className="section-title">About Me</Title>
          <Paragraph className="section-subtitle">Get to know me better</Paragraph>
        </div>
        
        <Row gutter={[32, 32]} style={{ marginBottom: '40px' }}>
          <Col xs={24} lg={16}>
            <div className="fade-in-up">
              <Title level={3} style={{ marginBottom: '20px', color: '#1890ff' }}>
                About Me
              </Title>
              
              <Paragraph style={{ 
                fontSize: window.innerWidth <= 768 ? '1rem' : '1.1rem', 
                lineHeight: 1.7, 
                marginBottom: '24px' 
              }}>
                Results-driven Software Engineer and Graphics Designer with 8+ years of 
                experience developing scalable full-stack applications, financial systems, and 
                Linux server solutions. Proven track record of delivering multitenant SaaS platforms 
                serving 500+ businesses and real-time applications supporting 10,000+ concurrent users. 
                Expert in client requirements analysis, system architecture design, and end-to-end 
                digital solution delivery combining technical expertise with advanced graphic design capabilities.
              </Paragraph>
              
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Card size="small" style={{ height: '100%' }}>
                    <Title level={4} style={{ color: '#1890ff', marginBottom: '8px', fontSize: '16px' }}>
                      My Mission
                    </Title>
                    <Paragraph style={{ marginBottom: 0, fontSize: '14px' }}>
                      Build scalable, efficient applications that solve real-world problems 
                      and make a positive impact on businesses and communities.
                    </Paragraph>
                  </Card>
                </Col>
                <Col xs={24} sm={12}>
                  <Card size="small" style={{ height: '100%' }}>
                    <Title level={4} style={{ color: '#1890ff', marginBottom: '8px', fontSize: '16px' }}>
                      My Approach
                    </Title>
                    <Paragraph style={{ marginBottom: 0, fontSize: '14px' }}>
                      Clean, maintainable code and user-centered design. Focus on creating 
                      solutions that are both technically robust and visually appealing.
                    </Paragraph>
                  </Card>
                </Col>
              </Row>
            </div>
          </Col>
          
          <Col xs={24} lg={8}>
            <div className="fade-in-up" style={{ animationDelay: '0.2s' }}>
              <Row gutter={[12, 12]}>
                <Col xs={12} sm={12}>
                  <Card style={{ textAlign: 'center', height: window.innerWidth <= 768 ? '80px' : '100px' }}>
                    <Statistic
                      title="Experience"
                      value={8}
                      suffix="+ years"
                      valueStyle={{ color: '#1890ff', fontSize: window.innerWidth <= 768 ? '18px' : '20px' }}
                    />
                  </Card>
                </Col>
                <Col xs={12} sm={12}>
                  <Card style={{ textAlign: 'center', height: window.innerWidth <= 768 ? '80px' : '100px' }}>
                    <Statistic
                      title="Projects"
                      value={50}
                      suffix="+"
                      valueStyle={{ color: '#1890ff', fontSize: window.innerWidth <= 768 ? '18px' : '20px' }}
                    />
                  </Card>
                </Col>
                <Col xs={12} sm={12}>
                  <Card style={{ textAlign: 'center', height: window.innerWidth <= 768 ? '80px' : '100px' }}>
                    <Statistic
                      title="Businesses"
                      value={500}
                      suffix="+"
                      valueStyle={{ color: '#1890ff', fontSize: window.innerWidth <= 768 ? '18px' : '20px' }}
                    />
                  </Card>
                </Col>
                <Col xs={12} sm={12}>
                  <Card style={{ textAlign: 'center', height: window.innerWidth <= 768 ? '80px' : '100px' }}>
                    <Statistic
                      title="Users"
                      value={10}
                      suffix="K+"
                      valueStyle={{ color: '#1890ff', fontSize: window.innerWidth <= 768 ? '18px' : '20px' }}
                    />
                  </Card>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default About;